'use strict';

module.exports = /* @ngInject */ function () {
	return {
		restrict: 'E',
		scope: {
			orderId: '=',
		},
		templateUrl: `./${BUILD_PATH}/list-linked-orders.directive.tpl.html`,
		controller: /* @ngInject */ function ($scope, translationService, linkOrderService, notificationService, aclService) {

			const ACL_RESOURCE = 'order.relation';
			const ACL_ACTION = 'show';

			$scope.orderLinks = null;

			$scope.popupOpen = true;

			$scope.init = init;
			$scope.deleteRelation = deleteLink;
			$scope.openOrder = openOrder;

			function init() {
				aclService.getPermission(ACL_RESOURCE, ACL_ACTION).then(permission => {
					if (permission.allow) {
						$scope.popupOpen = window.popupIsOpen();
						linkOrderService.getLinkedOrdersForOrderByOrderId.query({orderId: $scope.orderId}).$promise.then(links => {
							$scope.orderLinks = links;
						}, (error) => {
							const errorMessage = translationService.translate(_('Fehler beim Laden der verknüpften Bestellung'));
							notificationService.showErrorNotification(errorMessage);
							console.error(error);
						})
					}
				});
			}

			/**
			 * Redirects the page to the given order
			 * @param relation
			 */
			function openOrder(relation) {
				let url;

				if(window.location.hash.includes('my_adm/order')){
				    url = `my_adm/order/my_adm_order_show.htm&VS_ORDER_ID=${relation.order.id}`;
                } else {
                    url = `my_shop/my_order/my_order_show.htm&VS_ORDER_ID=${relation.order.id}`;
                }
				window.openContent(url);
			}

			/**
			 * Deletes an order link
			 * @param relation
			 */
			function deleteLink(relation) {
				linkOrderService.deleteOrderLink.query({orderId: relation.id}).$promise.then(() => {
					$scope.orderLinks = $scope.orderLinks.filter(link => link.id !== relation.id);
					const successMessage =
						translationService.translate(
							_(`Verknüpfung der Bestellungen ${$scope.orderId} und ${relation.order.id} wurde erfolgreich gelöst.`));
					notificationService.showSuccessNotification(successMessage);
				}, (error) => {
					const errorMessage =
						translationService.translate(_('Fehler beim löschen der der verknüpften Bestellung'));
					notificationService.showErrorNotification(errorMessage);
					console.error(error);
				})
			}
		}
	};
}
